import { createSelector } from 'reselect'
import getCollectionIdFeaturedDealsSelect from 'modules/featured-deals/redux/selectors/get-collection-id'
import getEndpointLoadRelatedProductUtil from 'modules/variant/redux/actions/load-related-products/selectors/utils/get-endpoint-util/index.js'

const getEndpointLoadRelatedProductSelect = createSelector(
  getCollectionIdFeaturedDealsSelect,
  (
    featuredCollectionId
  ) => getEndpointLoadRelatedProductUtil(featuredCollectionId)
)

export default getEndpointLoadRelatedProductSelect
